import React from "react";
import { ShoppingCart, Send, Mail } from "lucide-react";
import { PURCHASE_URL, SUPPORT_EMAIL, TELEGRAM_URL } from "../mock";

const CTASection = () => {
  return (
    <section className="relative py-24 px-4 border-t border-slate-800/70">
      <div className="mx-auto max-w-3xl text-center">
        <p className="text-xs font-semibold tracking-[0.3em] text-sky-400 uppercase">
          Lifetime Access
        </p>
        <h2 className="mt-3 text-3xl sm:text-4xl md:text-5xl font-extrabold text-white">
          Ready To Trade Smarter?
        </h2>
        <p className="mt-4 text-slate-400 max-w-xl mx-auto">
          Get the Swift-AI TradingView Indicator + 3 free Chartink scanners.
          One-time payment · Lifetime validity · Free future updates.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={PURCHASE_URL}
            target="_blank"
            rel="noreferrer"
            className="group inline-flex items-center gap-3 rounded-full bg-gradient-to-r from-sky-500 to-blue-600 px-10 py-4 font-bold tracking-wider text-white shadow-[0_0_40px_rgba(59,130,246,0.5)] transition-transform duration-300 hover:scale-[1.03] hover:shadow-[0_0_60px_rgba(59,130,246,0.75)]"
          >
            <ShoppingCart className="h-4 w-4" />
            <span className="text-sm">BUY NOW · LIFETIME ACCESS</span>
          </a>
          <a
            href={TELEGRAM_URL}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 rounded-full border border-slate-700 bg-slate-900/50 px-6 py-3.5 text-sm font-semibold text-slate-200 hover:border-sky-400/60 hover:text-white transition-colors"
          >
            <Send className="h-4 w-4 text-sky-400" />
            Free Telegram Channel
          </a>
        </div>

        <div className="mt-10 inline-flex flex-col sm:flex-row items-center gap-2 rounded-2xl border border-slate-800 bg-slate-900/40 px-6 py-4 text-sm text-slate-300">
          <Mail className="h-4 w-4 text-sky-400" />
          <span>
            After purchase, send your TradingView ID to{" "}
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              className="font-semibold text-sky-400 hover:text-sky-300"
            >
              {SUPPORT_EMAIL}
            </a>{" "}
            for activation.
          </span>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
